// extracted by mini-css-extract-plugin
module.exports = {"card":"sw","defaultCard":"tw","cardDetails":"uw","cardActions":"vw","separator":"ww"};